import { MenuItem, Select, TextField } from '@mui/material'
import { PERIOD_OPTIONS, ROLE_OPTIONS, STATUS_OPTIONS } from './constants'
import { ROUTE_FILTER_OPTIONS } from '../../utils/routeClassifier'

export function CRMFiltersBar({
  currency,
  setCurrency,
  role,
  setRole,
  period,
  setPeriod,
  status,
  setStatus,
  routeFilter,
  setRouteFilter,
  userId,
  setUserId,
  setOffset,
  loading,
  handleClearFilters,
  openSortModal,
  setExportModalOpen
}) {
  return (
    <div className='bg-white dark:bg-dk-surface rounded-xl shadow-sm p-4 mb-4'>
      <div className='flex flex-wrap items-end gap-3'>
        <div className='flex flex-col w-full sm:w-auto'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>País</span>
          <Select
            size='small'
            value={currency}
            onChange={e => {
              setCurrency(e.target.value)
              setOffset(0)
            }}
            sx={{ minWidth: 160 }}
          >
            <MenuItem value='all'>🌎 Ambos países</MenuItem>
            <MenuItem value='ARS'>🇦🇷 Argentina</MenuItem>
            <MenuItem value='UYU'>🇺🇾 Uruguay</MenuItem>
          </Select>
        </div>
        <div className='flex flex-col w-full sm:w-auto'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>Rol</span>
          <Select
            size='small'
            value={role}
            onChange={e => {
              setRole(e.target.value)
              setOffset(0)
            }}
            sx={{ minWidth: 160 }}
          >
            {ROLE_OPTIONS.map(o => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className='flex flex-col w-full sm:w-auto'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>Período</span>
          <Select
            size='small'
            value={period}
            onChange={e => {
              setPeriod(e.target.value)
              setOffset(0)
            }}
            sx={{ minWidth: 160 }}
          >
            {PERIOD_OPTIONS.map(o => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className='flex flex-col w-full sm:w-auto'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>Estado</span>
          <Select
            size='small'
            value={status}
            onChange={e => {
              setStatus(e.target.value)
              setOffset(0)
            }}
            sx={{ minWidth: 160 }}
          >
            {STATUS_OPTIONS.map(o => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className='flex flex-col w-full sm:w-auto'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>Ruta</span>
          <Select
            size='small'
            value={routeFilter}
            onChange={e => {
              setRouteFilter(e.target.value)
              setOffset(0)
            }}
            sx={{ minWidth: 160 }}
          >
            {ROUTE_FILTER_OPTIONS.map(o => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className='flex flex-col flex-1 min-w-[220px]'>
          <span className='text-xs uppercase font-medium text-gray dark:text-gray-400 mb-1'>ID de usuario</span>
          <TextField
            size='small'
            placeholder='Id de usuario'
            value={userId}
            onChange={e => {
              setUserId(e.target.value)
              setOffset(0)
            }}
          />
        </div>
        <div className='ml-auto flex gap-2 w-full sm:w-auto justify-end'>
          <button
            className='px-3 py-2 rounded-lg bg-light_gray dark:bg-dk-raised text-black dark:text-gray-100 hover:opacity-90 disabled:opacity-50'
            onClick={handleClearFilters}
            disabled={loading}
          >
            Limpiar
          </button>
          <button
            className='px-3 py-2 rounded-lg bg-primary text-white hover:opacity-90 disabled:opacity-50'
            onClick={openSortModal}
            disabled={loading}
          >
            Ordenar
          </button>
          {setExportModalOpen && (
            <button
              className='px-3 py-2 rounded-lg bg-primary text-white hover:opacity-90 disabled:opacity-50'
              onClick={() => setExportModalOpen(true)}
              disabled={loading}
            >
              Exportar
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
